import './main.css'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AccountSetup from './pages/AccountSetup';
import AgencyRegistration from './pages/AgencyRegistration';
import UserRegistration from './pages/UserRegistration';
import LinkGoogleAccount from './pages/LinkGoogleAccount';
import LinkGoogleAccountErr from './pages/LinkGoogleAccountError';
import ListCompanies from './pages/ListCompanies';
import ListCompaniesNew from './pages/ListCompaniesNew';
import DataImportProgress from './pages/DataImportProgress';
import Settings from './pages/Settings';
import Dashboard from './pages/Dashboard'; 
import TestCycle from './pages/TestCycle';
import ManageAccounts from './pages/ManageAccounts';
import MySettings from './pages/MySettings';
import AddTestTitle from './pages/AddTestTitle';
import ViewCycle from './pages/ViewCycle'; 
import OutputFeeds from './pages/OutputFeeds';
import EditOutputFeed from './pages/EditOutputFeed';
import DataFields from './pages/DataFields';
import Titles from './pages/Titles';
import Images from './pages/Images';
import Categories from './pages/Categories';
import CustomLabels from './pages/CustomLabels';
import ProductDetails from './pages/ProductDetails';
import Keywords from './pages/Keywords';
import ProductHighlights from './pages/ProductHighlights';
import Homepage from './pages/Homepage';
import HowItWorks from './pages/static/HowItWorks';
import Pricing from './pages/static/Pricing';
import Integration from './pages/static/Integration';
import AboutUs from './pages/static/AboutUs';
import Careers from './pages/static/Careers';
import TheTeam from './pages/static/TheTeam';
import ContactUs from './pages/static/ContactUs';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Products from './pages/Products';
import AddNewCompany from './pages/AddNewCompany';
import AddNewCompanyGmc from './pages/AddNewCompanyGmc';
import AddNewCompanyGB from './pages/AddNewCompanyGB';
import PerformanceReport from './pages/PerformanceReport';
import QCReport from './pages/QCReport'; 
import QCReportDev from './pages/QCReportDev'; 
import QCReportDev1 from './pages/QCReportDev1'; 
import QCReportDev2 from './pages/QCReportDev2';
import QCReportDev3 from './pages/QCReportDev3'; 

import AdwordsSync from './pages/AdwordsSync';
import AdwordsConnect from './pages/AdwordsConnect';
import SessionProvider, { useSession } from './components/session-provider';
import ManageUsers from './pages/ManageUsers';
import AddUser from './pages/AddUser'; 
import AddUser1 from './pages/AddUser1';
import ForgotPassword from './pages/ForgotPassword';
import CycleConfig from './pages/CycleConfig';
import { AlertProvider } from "./components/customAlert";
import ScrollToTop from "./components/ScrollToTop";
import MyAccount from './pages/MyAccount'
import AddTestTitleNew1 from './pages/AddTestTitle-new1';
import AddTestTitleNew2 from './pages/AddTestTitle-new2';
import AddTestTitleNew3 from './pages/AddTestTitle-new3';

function ProtectedRoute({ element }) {
  const { session, setSession } = useSession();

  if (!session?.loggedIn) {
    return <Navigate to="/" replace />;
  }
  return element;
}

function App() {
  return (
    <div className='App'>
      <BrowserRouter basename="/">
		<ScrollToTop />
		<SessionProvider>
			<AlertProvider>
				<Routes>
					<Route path="/account-setup" element={<AccountSetup/>} />
					<Route path="/agency-registration" element={<AgencyRegistration/>} />
					<Route path="/user-registration" element={<UserRegistration/>} />
					<Route path="/link-google-account" element={<LinkGoogleAccount/>} />
					<Route path="/link-google-account-err" element={<LinkGoogleAccountErr/>} />
					<Route path="/list-companies" element={<ListCompanies/>} />
					<Route path="/list-companies-new" element={<ListCompaniesNew/>} />
					<Route path="/data-import-progress" element={<DataImportProgress/>} />
					<Route path="/" element={<Homepage />} />
					<Route path="/how-it-works" element={<HowItWorks />} />
					<Route path="/pricing" element={<Pricing />} />
					<Route path="/integration" element={<Integration />} />
					<Route path="/about-us" element={<AboutUs />} />
					<Route path="/careers" element={<Careers />} />
					<Route path="/the-team" element={<TheTeam />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/login" element={<Login />} />
					<Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
					<Route path="/settings" element={<ProtectedRoute element={<Settings />} />} />
					<Route path="/data-fields" element={<ProtectedRoute element={<DataFields />} />} />
					<Route path="/titles" element={<ProtectedRoute element={<Titles />} />} />
					<Route path="/title-test/add-title-test/id/:actionType" element={<ProtectedRoute element={<AddTestTitle />} />} />
					<Route path="/title-test/add-title-test/id/:actionType/:cycleId" element={<ProtectedRoute element={<AddTestTitle />} />} />
					<Route path="/title-test/view-title-test/id/:actionType/:cycleId" element={<ProtectedRoute element={<ViewCycle />} />} />  
		  
	  	  <Route path="/title-test/add-title-test1/id/:actionType" element={<ProtectedRoute element={<AddTestTitleNew1 />} />} />
	  <Route path="/title-test/add-title-test2/id/:actionType" element={<ProtectedRoute element={<AddTestTitleNew2 />} />} />
	  <Route path="/title-test/add-title-test3/id/:actionType" element={<ProtectedRoute element={<AddTestTitleNew3 />} />} />
	  
					<Route path="/images" element={<ProtectedRoute element={<Images />} />} />
					<Route path="/categories" element={<ProtectedRoute element={<Categories />} />} />
					<Route path="/custom-labels" element={<ProtectedRoute element={<CustomLabels />} />} />
					<Route path="/product-details" element={<ProtectedRoute element={<ProductDetails />} />} />
					<Route path="/keywords" element={<ProtectedRoute element={<Keywords />} />} />
					<Route path="/product-highlights" element={<ProtectedRoute element={<ProductHighlights />} />} />
					<Route path="/title-test" element={<ProtectedRoute element={<TestCycle />} />} />
					
					 
					
					
					<Route path="/manage-accounts" element={<ProtectedRoute element={<ManageAccounts />} />} />
					<Route path="/my-settings" element={<ProtectedRoute element={<MySettings />} />} />
					<Route path="/output-feeds" element={<ProtectedRoute element={<OutputFeeds />} />} />
					<Route path="/edit-output-feed/id/:feedId" element={<ProtectedRoute element={<EditOutputFeed />} />} />
					<Route path="/products" element={<ProtectedRoute element={<Products />} />} />
					<Route path="/add-new-company" element={<ProtectedRoute element={<AddNewCompany />} />} />
					<Route path="/add-new-company-gmc" element={<ProtectedRoute element={<AddNewCompanyGmc />} />} />
					<Route path="/add-new-company-gb" element={<ProtectedRoute element={<AddNewCompanyGB />} />} />
					<Route path="/title-test/performance-report/id/:cycleMasterId" element={<ProtectedRoute element={<PerformanceReport />} />} /> 
					<Route path="/title-test/qc-report/id/:cycleMasterId" element={<ProtectedRoute element={<QCReport />} />} />
					<Route path="/title-test/qc-report-dev/id/:cycleMasterId" element={<ProtectedRoute element={<QCReportDev />} />} /> 
					<Route path="/title-test/qc-report-dev1/id/:cycleMasterId" element={<ProtectedRoute element={<QCReportDev1 />} />} />
					<Route path="/title-test/qc-report-dev2/id/:cycleMasterId" element={<ProtectedRoute element={<QCReportDev2 />} />} />
					<Route path="/title-test/qc-report-dev3/id/:cycleMasterId" element={<ProtectedRoute element={<QCReportDev3 />} />} />
					<Route path="/adwords-sync" element={<ProtectedRoute element={<AdwordsSync />} />} />
					<Route path="/adwords-connect" element={<ProtectedRoute element={<AdwordsConnect />} />} />
					<Route path="/manage-users" element={<ProtectedRoute element={<ManageUsers />} />} />	
					<Route path="/manage-users/add" element={<ProtectedRoute element={<AddUser />} />} />	
					<Route path="/manage-users/edit/id/:userid" element={<ProtectedRoute element={<AddUser />} />} />

					<Route path="/manage-users/add1" element={<ProtectedRoute element={<AddUser1 />} />} />
					<Route path="/logout" element={<Logout />} />
					<Route path="/my-account" element={<MyAccount />} />
					<Route path="/forgot-password" element={<ForgotPassword />} />
					<Route path="/title-test/cycle-settings" element={<ProtectedRoute element={<CycleConfig />} />} />
				</Routes>
			</AlertProvider>
		</SessionProvider>
      </BrowserRouter>
    </div>
  )
}

export default App;